import { useTranslate } from "@similarweb/i18n-provider";

import * as SC from "../BodyByState/styles";
import type { MetricCardVariant } from "../BodyByState/types";

type MetricCardProps = {
    value: number;
    labelKey: string;
    variant: MetricCardVariant;
    dataAutomation?: string;
};

export const MetricCard = ({ value, labelKey, variant, dataAutomation }: MetricCardProps) => {
    const { translate } = useTranslate();

    return (
        <SC.MetricCard
            $variant={variant}
            data-automation={dataAutomation}
        >
            <SC.MetricCardValue
                $variant={variant}
                fontVariant="h4"
            >
                {value}
            </SC.MetricCardValue>
            <SC.MetricCardLabel
                $variant={variant}
                fontVariant="listItem3"
            >
                {translate(labelKey)}
            </SC.MetricCardLabel>
        </SC.MetricCard>
    );
};
